import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSortable } from "@dnd-kit/sortable";
import { ActionIcon, Flex, Text } from "@mantine/core";
import { Delete, DragIndicatorOutlined, Edit } from "@mui/icons-material";
import { SvgIcon } from "@mui/material";
export const SortablePriorityView = ({ priorityView, onClickEdit, onClickDelete }) => {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
        id: priorityView.priorityViewId
    });
    return (_jsxs(Flex, { ref: setNodeRef, className: "hover-opacity-parent", justify: "space-between", style: {
            paddingRight: "1rem",
            marginTop: "0.2rem",
            borderRadius: "0.2rem",
            backgroundColor: "var(--mantine-color-primary-3)",
            minHeight: "2rem",
            fontWeight: "600",
            display: "flex",
            alignItems: "center",
            cursor: "grab",
            transform: transform
                ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
                : undefined,
            transition
        }, children: [_jsx("div", { style: {
                    width: "100%"
                }, ...attributes, ...listeners, children: _jsx(Flex, { style: { width: "100%" }, justify: "space-between", children: _jsxs(Flex, { align: "center", children: [_jsx(SvgIcon, { component: DragIndicatorOutlined, style: {
                                    fontSize: "1rem",
                                    color: "grey",
                                    marginLeft: "0.5rem"
                                } }), _jsx(Text, { variant: "body", style: {
                                    marginLeft: "0.5rem",
                                    fontSize: "smaller"
                                }, children: priorityView.name })] }) }) }), _jsxs(Flex, { children: [_jsx(ActionIcon, { variant: "transparent", onClick: () => onClickEdit(priorityView), children: _jsx(SvgIcon, { className: "hover-opacity", component: Edit, style: { fontSize: "1rem", color: "grey" } }) }), _jsx(ActionIcon, { variant: "transparent", onClick: () => onClickDelete(priorityView), children: _jsx(SvgIcon, { className: "hover-opacity", component: Delete, style: { fontSize: "1rem", color: "grey" } }) })] })] }));
};
